export class PassEncryption {
	a1: string;
	m1: string;
	m2: string;

	constructor() {
		this.a1 = null;
		this.m1 = null;
		this.m2 = null;
	}
}